export const TOGGLE_DEVICE = 'TOGGLE_DEVICE'

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'

export const EXPAND_MENU = 'EXPAND_MENU'

export const SWITCH_EFFECT = 'SWITCH_EFFECT'

export const UPDATE_EDIT_LABEL = 'UPDATE_EDIT_LABEL'

export const FILTER_UNAUTHORIZED_ITEMS = 'FILTER_UNAUTHORIZED_ITEMS'

export const SET_USER = 'SET_USER'

export const SET_PROJECTS_COUNT = 'SET_PROJECTS_COUNT'

export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION'

export const SET_PLAN_PRICES = 'SET_PLAN_PRICES'
